(function () {
  'use strict';

  const getMoneyFormat = () => window.themeSettings?.moneyFormat || '${{amount}}';

  const formatWithTemplate = (cents, moneyFormat) => {
    const value = cents / 100;
    const amount = value.toFixed(2);
    const amountNoDecimals = Math.round(value).toString();
    const amountWithCommaSeparator = amount.replace('.', ',');
    const amountNoDecimalsWithCommaSeparator = amountNoDecimals;
    const amountWithApostropheSeparator = amount.replace(/\B(?=(\d{3})+(?!\d))/g, "'");

    return moneyFormat
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amountWithCommaSeparator)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amountNoDecimalsWithCommaSeparator)
      .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, amountWithApostropheSeparator)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  };

  const formatMoney = (cents, format) => {
    const parsedCents = typeof cents === 'number' ? cents : parseInt(cents, 10) || 0;
    const moneyFormat = format || getMoneyFormat();

    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(parsedCents, moneyFormat);
    }

    return formatWithTemplate(parsedCents, moneyFormat);
  };

  window.themeFormatMoney = formatMoney;
})();
